<header class="page-head">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-bank"></i></span>
    <div>
      <h1 class="page-head__title">Pagamentos realizados</h1>
    </div>
  </div>
  <div class="page-head__actions">
    <button type="button" class="sf-btn sf-btn--secondary" routerLink="/partner-management">
      <i class="fa fa-arrow-left"></i> Voltar
    </button>
  </div>
</header>

<div class="sf-card" *ngIf="agency$ | async as agency">
  <div class="section-title">{{ agency.name }}</div>
  <app-skeleton *ngIf="loading" variant="table-row" [count]="6" [columns]="5"
    label="Carregando os pagamentos da agência" data-testid="agency-payments-loading"></app-skeleton>

  <table class="table" *ngIf="payments$ | async as payments">
    <thead>
      <tr>
        <th>Período</th>
        <th>Data Pagamento</th>
        <th>Tipo</th>
        <th>Valor</th>
        <th>Observação</th>
        <th></th>
      </tr>
    </thead>
    <tbody *ngIf="payments.data.length > 0">
      <tr *ngFor="let payment of payments.data">
        <td>{{ payment.user_commission.period | period }}</td>
        <td>{{ payment.payment_date | date : "dd/MM/yyyy" }}</td>
        <td>{{ payment.type }}</td>
        <td>{{ payment.amount | numberFormat : "R$ " : true : 2 }}</td>
        <td>{{ payment.description }}</td>
        <td>
          <button
            type="button"
            class="sf-btn sf-btn--danger sf-btn--icon sf-btn--sm"
            (click)="confirmDelete(payment)"
            *ngIf="payment.type !== 'sms'"
            ngbTooltip="Excluir"
          >
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr *ngIf="payments.data.length === 0">
        <td colspan="6">Nenhum pagamento realizado.</td>
      </tr>
    </tfoot>
  </table>
</div>
